import AmplifyWrapper from '../service/auth.service';

// - - REQUEST_RESET_PASSWORD ACTIONS

export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS';
export const REQUEST_RESET_PASSWORD_ERROR = 'REQUEST_RESET_PASSWORD_ERROR';

const requestRequestResetPassword = username => {
	return {
		type: REQUEST_RESET_PASSWORD,
		username
	};
};

const recieveRequestResetPasswordSuccess = data => {
	return {
		type: REQUEST_RESET_PASSWORD_SUCCESS,
		data
	};
};

const recieveRequestResetPasswordError = error => {
	return {
		type: REQUEST_RESET_PASSWORD_ERROR,
		error
	};
};

export const requestResetPassword = username => {
	return async function(dispatch) {
		//
		dispatch(requestRequestResetPassword(username));

		AmplifyWrapper.forgotPassword(username)
			.then(data => {
				dispatch(recieveRequestResetPasswordSuccess(data));
			})
			.catch(err => {
				dispatch(recieveRequestResetPasswordError(err));
			});
	};
};
